(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["studio-work-specifications"] && !Shopify.designMode) return;
  try {
    
(function() {
  document.querySelectorAll('.sw-spec__trigger').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var item = btn.closest('.sw-spec__item');
      var body = item.querySelector('.sw-spec__body');
      var isOpen = item.classList.contains('is-open');
      item.classList.toggle('is-open', !isOpen);
      btn.setAttribute('aria-expanded', String(!isOpen));
      body.style.maxHeight = isOpen ? '0' : body.scrollHeight + 'px';
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["studio-work-use-scale"] && !Shopify.designMode) return;
  try {
    
(function() {
  var videos = document.querySelectorAll('[data-sw-video]');
  if (!videos.length || !('IntersectionObserver' in window)) return;
  var observer = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      var mp4 = entry.target.querySelector('[data-sw-mp4]');
      var yt = entry.target.querySelector('[data-sw-yt]');
      if (entry.isIntersecting) {
        if (mp4) mp4.play();
        if (yt) {
          var src = yt.src;
          if (src.indexOf('autoplay=0') > -1) yt.src = src.replace('autoplay=0', 'autoplay=1');
        }
      } else {
        if (mp4) mp4.pause();
      }
    });
  }, { threshold: 0.4 });
  videos.forEach(function(v) { observer.observe(v); });
})();

  } catch(e) { console.error(e); }
})();
})();
